<script lang="ts">
	import type { FilterCheckboxList } from '../../../types';
	import { FilterDrawerCheckboxes } from './FilterDrawerCheckboxes';
	import FilterDrawerRadios from './FilterDrawerRadios/FilterDrawerRadios.svelte';

	interface Props {
		filterCollectionId: string;
		filterCheckboxList: FilterCheckboxList;
	}

	let { filterCollectionId, filterCheckboxList }: Props = $props();

	let type = $derived(filterCheckboxList.type as 'checkbox' | 'radio');
</script>

<div class="py-2">
	{#if type === 'checkbox'}
		<FilterDrawerCheckboxes {filterCollectionId} {filterCheckboxList} />
	{/if}

	{#if type === 'radio'}
		<FilterDrawerRadios {filterCollectionId} {filterCheckboxList} />
	{/if}
</div>
